// extracted by mini-css-extract-plugin
export default {"galleryItem":"c-g_eH","galleryItem_borderTopRadius":"c-g_eJ","galleryItem__image":"c-g_eK"};